import { FeatureFlagsState } from '@/@types'

const state: FeatureFlagsState = {
  blackFridayEnabled: false,
  cyberMondayEnabled: false,
  tcsPromoEnabled: false,
  flashSaleEnabled: false,
  showB2BBanner: false,
  premiumPlusEnabled: false,
  springPromoEnabled: false,
  maySaleEnabled: false,
  mayFlashSaleEnabled: false,
  summerSavingsEnabled: false,
  julySaleEnabled: false,
  showDefaultSmallPrint: false,
  hubspotIntegration: false,
  certs50percentDiscount: false,
  restrictStandAloneCertsEnabled: false,
}

export default state
